/* globals google */

'use strict';

var features = JSON.parse(document.querySelector('body').dataset.features);
var storeLocatorViewportCenterString = features.storeLocatorViewportCenter;
var storeLocatorUnitTranslation = features.storeLocatorUnitTranslation ? features.storeLocatorUnitTranslation : null;
var $storeLocator = $('#store-locator');
// default US lat and long
var map;
var markers = [];
var defaultLat = 37.09024;
var defaultLong = -95.712891;
var latlng;
var distanceUnit = $storeLocator.data('distanceunit');

/**
 * Check if string is json
 * @param {string} str - string to check
 * @returns {boolean} if it's a string or no
 */
function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

if (isJsonString(storeLocatorViewportCenterString)) {
    var storeLocatorViewportCenterJson = JSON.parse(storeLocatorViewportCenterString);
    try {
        if (storeLocatorViewportCenterJson.lat && storeLocatorViewportCenterJson.long) {
            defaultLat = parseFloat(JSON.parse(storeLocatorViewportCenterString).lat);
            defaultLong = parseFloat(JSON.parse(storeLocatorViewportCenterString).long);
        }
    } catch (e) {
        console.error('check the default lat and long preference values, make sure they can be parsed to a float value')
    }
}

var mapOptions = {
    gestureHandling: 'cooperative',
    zoom: 9
};

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Inits events for code rendered after the ajax
 */
function initControls() {
    var $storeCard = $storeLocator.find('.store-locator-container .results-panel .store-card');

    $storeLocator.find('.update-location-btn').on('click', function () {
        $storeLocator.find('.results-panel').removeClass('js-show').addClass('js-hide');
        $storeLocator.find('.search-form').removeClass('js-hide').addClass('js-show');
        $storeLocator.find('.results-only, .map-footer').removeClass('js-active');
    });

    $storeLocator.find('.btn-map-view').on('click', function () {
        if ($(this).is('.js-off')) {
            $storeLocator.find('.btn-list-view').addClass('js-off');
            $(this).removeClass('js-off');
            $storeLocator.find('.map-canvas').addClass('js-show');
            drawMap();
        }
    });

    $storeLocator.find('.btn-list-view').on('click', function () {
        if ($(this).is('.js-off')) {
            $storeLocator.find('.btn-map-view').addClass('js-off');
            $(this).removeClass('js-off');
            $storeLocator.find('.map-canvas').removeClass('js-show');
        }
    });

    $storeLocator.find('.info-trigger').each(function () {
        $(this).find('.store-info-trigger').on('click', function (event) {
            event.preventDefault();
            if ($(this).parents('.store-card').find('.store-info').is('.js-active')) {
                $(this).removeClass('js-active');
                $(this).parents('.store-card').find('.store-info').removeClass('js-active');
            } else {
                $(this).addClass('js-active');
                $(this).parents('.store-card').find('.store-info').addClass('js-active');
            }
        });
    });

    $storeCard.find('.map-marker, .store-details-l1').on('click', (function () {
        var $storeCardParent = $(this).parents('.store-card');
        var storeIndex = $storeCardParent.data('storeindex') - 1;

        google.maps.event.trigger(markers[storeIndex], 'click');
    }));
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    $storeLocator.find('.results-panel').addClass('js-show').removeClass('js-hide');
    $storeLocator.find('.search-form').addClass('js-hide').removeClass('js-show');

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
        $storeLocator.find('.map-showing-note .store-count').html(data.stores.length);
        $storeLocator.find('.locator-radius .radius').val(data.radius);
        $storeLocator.find('.locator-radius .radius option[value="' + data.radius + '"]').prop('selected', true);
    }

    if ($mapDiv.data('has-google-api')) {
        drawMap(data);
    } else {
        $('.store-locator-no-apiKey').show();
    }

    initControls();
    trackGtmStoreResults(hasResults, data.stores.length);
}

/**
 * 
 * @param {boolean} hasResults 
 * @param {number} numberOfResults 
 */
function trackGtmStoreResults(hasResults, numberOfResults) {
    //interacting with Store locator widget
    var dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'find_a_nearby_store',
        'num_search_results': numberOfResults,
        'location_search_keyword': "",
        'page_name': $('title').html(),
        'page_location': window.location.href,
        'hit_timetamp': new Date().toLocaleTimeString([], { hour12: false })
    });
}

/**
 * Enables user to search a map area after dragging the map and changing the center
 * @param {Object} latLng - map center data from Google Maps API
 */
function searchAfterDrag(latLng) {
    var radius = $storeLocator.find('.radius').val();
    var url = $storeLocator.find('.radius').data('action-url');
    var urlParams = {
        radius: radius,
        lat: latLng.lat(),
        long: latLng.lng()
    };

    url = appendToUrl(url, urlParams);
    var dialog = $(this).closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
}

/**
 * Destroys button for updating markers based on new map center
 */
function destroyMapUpdateBtn() {
    $('.map-canvas-outer .search-area-btn').remove();
}

/**
 * Creates button for updating markers based on new map center
 * @param {Object} latLng - map center data from Google Maps API
 */
function createMapUpdateBtn(latLng) {
    var $mapCanvas = $storeLocator.find('.map-canvas');
    var btnText = $mapCanvas.data('searchthisarea');

    $mapCanvas.parents('.map-canvas-outer').append('<button class="search-area-btn btn btn-primary">' + btnText + '</button>');

    $('.map-canvas-outer .search-area-btn').on('click', function () {
        searchAfterDrag(latLng);
        destroyMapUpdateBtn();
    });
}

/**
 * Uses google maps api to render a map
 * @param {Object} latLng - latLng object from Google Maps API
 * @param {string} postalCode - postal code
 * @param {Object} data - search data
 */
function buildMap(latLng, postalCode, data) {
    var marker;
    var activeMarker;
    var activeVal;
    var $results = $('.results');
    var latLngOrg = latLng;
    mapOptions.center = latLng;
    map = new google.maps.Map($storeLocator.find('.map-canvas')[0], mapOptions);
    var infowindow = new google.maps.InfoWindow();
    var searchKey = data.searchKey;

    if (postalCode) {
        $storeLocator.find('.showing-postalcode').html(postalCode);
        if(data.stores && data.stores.length>0){
            $storeLocator.find('.map-showing-note .store-count').html(data.stores.length);  
        }else{
            $storeLocator.find('.map-showing-note .store-count').html(0);
        }
        $storeLocator.find('.results-only, .map-footer').addClass('js-active');
    }else{
        $storeLocator.find('.showing-postalcode').html(searchKey.cityName);
        if(data.stores && data.stores.length>0){
            $storeLocator.find('.map-showing-note .store-count').html(data.stores.length);  
        }else{
            $storeLocator.find('.map-showing-note .store-count').html(0);
        }
        $storeLocator.find('.results-radius-refine .locator-radius').addClass('d-none');
    }

    var mapdiv = $storeLocator.find('.map-canvas').attr('data-locations');
    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    var maxZindex = google.maps.Marker.MAX_ZINDEX;

    // Customized google map marker icon with svg format
    var markerDefault = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: '#ffffff',
        fillOpacity: 1,
        scale: 17,
        strokeColor: '#004987',
        strokeWeight: 1.3,
        labelOrigin: new google.maps.Point(0, 0)
    };

    var markerActive = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: '#004987',
        fillOpacity: 1,
        scale: 17,
        strokeColor: '#004987',
        strokeWeight: 1.3,
        labelOrigin: new google.maps.Point(0, 0)
    };

    /**
     * Settings for default marker label
     * @param {string} labelVal - label value
     * @returns {Object} settings and their values
     */
    function labelDefault(labelVal) {
        return {
            text: labelVal.toString(),
            color: '#004987',
            fontSize: '16px'
        };
    }

    /**
     * Settings for active marker label
     * @param {string} labelVal - label value
     * @returns {Object} settings and their values
     */
    function labelActive(labelVal) {
        return {
            text: labelVal.toString(),
            color: '#ffffff',
            fontSize: '16px'
        };
    }

    if (mapdiv && mapdiv.length !== 0) {
        Object.keys(mapdiv).forEach(function (key) {
            var item = mapdiv[key];
            var label = parseInt(key, 10) + 1;
            var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            var storeID = item.ID;
            var $resultItem = $('.results #' + storeID);
            var resultsPos = $resultItem.position().top;

            marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name,
                icon: markerDefault,
                label: labelDefault(label)
            });

            marker.addListener('click', function () {
                if (activeMarker && activeVal) {
                    activeMarker.setIcon(markerDefault);
                    activeMarker.setLabel(labelDefault(activeVal));
                    activeMarker.setZIndex(1);
                }

                this.setIcon(markerActive);
                this.setLabel(labelActive(label));
                this.setZIndex(5);

                // update the value of activeMarker
                activeMarker = this;
                activeVal = label;

                infowindow.setOptions({
                    content: item.infoWindowHtml
                });

                infowindow.open({
                    anchor: this,
                    map
                });

                destroyMapUpdateBtn();
                $results.find('.store-card').removeClass('js-active');
                $resultItem.addClass('js-active');

                $('.results').animate(
                    {
                        scrollTop: resultsPos
                    },
                    'slow'
                );
            });

            markers.push(marker);

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);

            var mapCenter = map.getCenter();
            var markerLatLng = marker.getPosition();
            if(postalCode){
            var distance = google.maps.geometry.spherical.computeDistanceBetween(mapCenter, markerLatLng);
            }
            var distanceKMeters = (distance / 1000).toFixed(1);
            var distanceMiles = (distance * 0.000621371).toFixed(1);
            var distanceUnitTranslation;
            var distanceFrom;
            if (storeLocatorUnitTranslation) {
                distanceUnitTranslation = storeLocatorUnitTranslation;
                if (distanceUnit === 'km') {
                    distanceFrom = distanceKMeters + ' ' + distanceUnitTranslation;
                }
                if (distanceUnit === 'mi') {
                    distanceFrom = distanceMiles + ' ' + distanceUnitTranslation;
                }
            } else {
                if (distanceUnit === 'km' && postalCode) {
                    distanceUnitTranslation = 'Kilometers';
                    distanceFrom = distanceKMeters + ' ' + distanceUnitTranslation;
                }
                if (distanceUnit === 'mi' && postalCode) {
                    distanceUnitTranslation = 'Miles';
                    distanceFrom = distanceMiles + ' ' + distanceUnitTranslation;
                }
            }

            $('[data-store-id="' + storeID + '"]').find('.distance').html(distanceFrom);
        });

        // watch for zoom change and prevent auto zooming in too close when there is only a few results that are near to each other
        google.maps.event.addListener(map, 'zoom_changed', function () {
            var maxZoom = 13;
            var zoomChangeBoundsListener = google.maps.event.addListener(map, 'bounds_changed', function (event) {
                if (this.getZoom() > maxZoom && this.initialZoom == true) {
                    this.setZoom(maxZoom);
                    this.initialZoom = false;
                }
                google.maps.event.removeListener(zoomChangeBoundsListener);
            });
        });

        map.initialZoom = true;

        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        map.fitBounds(bounds);
    } else {
        // No Results, so center map on original search and set zoom on empty map
        if (!latLngOrg) {
            latLngOrg = new google.maps.LatLng(defaultLat, defaultLong)
        }
        map.setCenter(latLngOrg);
        map.setZoom(11);
    }

    google.maps.event.addListener(map, 'idle', function () {
        if (!this.get('dragging') && this.get('oldCenter') && this.get('oldCenter') !== this.getCenter()) {
            var newCenter = this.getCenter();
            createMapUpdateBtn(newCenter);
        }

        if (!this.get('dragging')) {
            this.set('oldCenter', this.getCenter());
        }
    });

    google.maps.event.addListener(map, 'dragstart', function () {
        this.set('dragging', true);
        destroyMapUpdateBtn();
    });

    google.maps.event.addListener(map, 'dragend', function () {
        this.set('dragging', false);
    });

    google.maps.event.addListener(map, 'zoom_changed', function () {
        destroyMapUpdateBtn();
    });
}

/**
 * Convert postal code to lat/long using Google Geocoder
 * @param {string} postalCode - postal code
 * @param {Object} data - search data
 */
function postalCodeSearch(postalCode, data) {
    var latLng = null;

    if (postalCode) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: postalCode + ", " + data.country }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var latitude = results[0].geometry.location.lat();
                var longitude = results[0].geometry.location.lng();
                latLng = new google.maps.LatLng(latitude, longitude);
            } else {
                console.error('Geocoder failed due to: ' + status);
            }

            buildMap(latLng, postalCode, data);
        });
    }
}

/**
 * Convert lat/long using to postal code using Google Geocoder
 * @param {Object} latLng - latLng object from Google Maps API
 * @param {Object} data - search data
 */
function latLongSearch(latLng, data) {
    var postalCode = null;

    if (latLng) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ latLng: latLng }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                    for (var j = 0; j < results[0].address_components.length; j++) {
                        if (results[0].address_components[j].types[0] == 'postal_code') {
                            postalCode = results[0].address_components[j].short_name;
                        }
                    }
                }
            } else {
                console.error('Geocoder failed due to: ' + status);
            }

            buildMap(latLng, postalCode, data);
        });
    }
}

/**
 * Draws default map, if there is no GeoLocation Data
 */
function drawNoGeolocation() {
    $.spinner().start();
    // Init U.S. Map in the center of the viewport
    latlng = new google.maps.LatLng(defaultLat, defaultLong);
    mapOptions.center = latlng;
    mapOptions.zoom = 4;

    map = new google.maps.Map($storeLocator.find('.map-canvas')[0], mapOptions);
    $.spinner().stop();
}

/**
 * Checks for Geolocation Error
 * @param {Object} error - string to check
 */
function showError(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            $.spinner().stop();
            console.warn('User denied the request for Geolocation.');
            $storeLocator.find('.detect-location').prop('disabled', true);
            $storeLocator.find('.detect-location-label').text($storeLocator.find('.detect-location-label').data('disabledmsg'));
            break;
        case error.POSITION_UNAVAILABLE:
            $.spinner().stop();
            console.warn('Location information is unavailable.');
            break;
        case error.TIMEOUT:
            $.spinner().stop();
            console.warn('The request to get user location timed out.');
            break;
        default:
        case error.UNKNOWN_ERROR:
            $.spinner().stop();
            console.warn('An unknown geolocation error occurred.');
            break;
    }

    drawNoGeolocation();
}

/**
 * Uses google maps api to render a map for page load
 */
function mapStart() {
    drawNoGeolocation();
    if (navigator.geolocation) {
        // Init Map in the center of current geolocation
        navigator.geolocation.getCurrentPosition(function (position) {
            $.spinner().start();
            defaultLat = position.coords.latitude;
            defaultLong = position.coords.longitude;

            latlng = new google.maps.LatLng(defaultLat, defaultLong);
            mapOptions.center = latlng;

            map = new google.maps.Map($storeLocator.find('.map-canvas')[0], mapOptions);
            $.spinner().stop();
        }, showError);
    }
}

/**
 * Sets up map render based on search key type
 * @param {Object} data - data returned from call to controller
 */
function drawMap(data) {
    var $results = $('.results');
    $results.find('.store-card').removeClass('js-active');
    var searchKey = data.searchKey;
    var postalCode;

    if (searchKey && searchKey.postalCode) {
        postalCode = searchKey.postalCode;
        postalCodeSearch(postalCode, data);
    } else if (searchKey && searchKey.lat && searchKey.long) {
        latlng = new google.maps.LatLng(searchKey.lat, searchKey.long);
        latLongSearch(latlng, data);
    } else {
        buildMap(latlng, postalCode, data);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius};

    var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="locations"]').val() };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
    return false;
}

/**
 * Scrolls to the #store-locator section if it exists in the URL hash.
 * This function should be called when the DOM is fully loaded.
 */

window.onload = function () {
    scrollToStoreLocator();
    handleStoreLocatorFieldError();
};

function scrollToStoreLocator() {
    if (window.location.hash === '#store-locator') {
        var storeLocatorElement = $('#store-locator');
        if (storeLocatorElement.length > 0) {
            window.scrollTo({
                top: storeLocatorElement.offset().top,
                behavior: 'smooth'
            });
        }
    }
}

function handleStoreLocatorFieldError() {
    var container = $('.store-locator-container');
    var invalidFeedbackStoreLocator = container.find('.invalid-feedback-storeLocator');
    var invalidFeedback = container.find('.invalid-feedback');

    // Target the button by its type and class attributes
    var button = container.find('button[type="submit"].btn-storelocator-search');

    // Add a click event listener to the button
    button.on('click', function () {
        // Show the store locator feedback and hide the general invalid feedback
        invalidFeedbackStoreLocator.removeClass('d-none').addClass('d-block');
        invalidFeedback.removeClass('d-block').addClass('d-none');
    });
}

module.exports = {
    init: function () {
        if ($storeLocator.find('.map-canvas').data('has-google-api')) {
            mapStart();
        } else {
            $storeLocator.find('.store-locator-no-apiKey').show();
        }

        if (!$storeLocator.find('.results').data('has-results')) {
            $storeLocator.find('.store-locator-no-results').show();
        }

        initControls();
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            }, showError);
        });
    },

    search: function () {
        $storeLocator.find('.store-locator-container form.store-locator').on('submit', function (e) {
            e.preventDefault();
            search($(this));
        });
        $storeLocator.find('.store-locator-container .btn-storelocator-search[type="button"]').on('click', function (e) {
            e.preventDefault();
            search($(this));
        });
    },

    changeRadius: function () {
        $storeLocator.find('.radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    locations: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    destroyMapUpdateBtn();
                    spinner.stop();
                    updateStoresResults(data);
                    if (searchKeys.lat && searchKeys.long) {
                        map.setCenter(new google.maps.LatLng(searchKeys.lat, searchKeys.long));
                    }
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },

    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-panel .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },

    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    },

    resize: function () {
        $(window).smartresize(function () {
            if ($storeLocator.find('.results-panel').is('.js-show')) {
                drawMap();
            }
        });
    }
};
